import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import LoginService from "../Service/LoginService";

const PASSWORD = process.env.REACT_APP_PASSWORD;

const GetTokenController = ({ username, password }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (username == "YannickSmigetzkiSCFPS" && password == `${PASSWORD}`) {
            
            sessionStorage.setItem('token', "");
            navigate("/formations");
        }
        // const fetchToken = async () => {
        //     try {
        //         let response = await LoginService.fetchToken(username, password);
        //         console.log(response);
        //         sessionStorage.setItem('token', response.data.token);
        //         navigate("/formations");
        //     } catch (error) {
        //         console.log("erreur" + error);
        //     }
        // };

        // fetchToken();
    }, [username, password, dispatch, navigate]);

    return null; // This component does not render anything
};

export default GetTokenController;